/**
 * Generates a string to be read as accessibility label
 *
 * @param {Object} params - Parameters
 * @param {string} params - The title of the tab
 * @param {number} params - The index number of the selected tab
 * @param {number} params - The index number of the tab
 * @param {number} params - The total number of tabs
 *
 * @returns {string} - A string to be used for tab accessibility label
 */

export const getAccessibilityLabel = ({
  title,
  activeTabIndex,
  count,
  tabIndex,
  totalTabs,
}: any) => {
  return `${title} tab, ${count !== undefined ? `, ${count} records` : ''}, ${
    activeTabIndex === tabIndex ? 'Selected, ' : ''
  } ${tabIndex + 1} of ${totalTabs}`;
};
